import { render, staticRenderFns } from "./LoaderWithFallback.vue?vue&type=template&id=72807b8e&scoped=true&"
import script from "./LoaderWithFallback.vue?vue&type=script&lang=js&"
export * from "./LoaderWithFallback.vue?vue&type=script&lang=js&"
import style0 from "./LoaderWithFallback.vue?vue&type=style&index=0&id=72807b8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72807b8e",
  null
  
)

export default component.exports